export const EventsTranslationsDictionary = {
    Events: "Events",
    NoEventNotifications: "No event notifications.",
    NewEventNotificationString: "Events ({0} new)",
    View: "View"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in EventsTranslationsDictionary) {
        r.push(EventsTranslationsDictionary[prop]);
    }
    return r;
};

export const EventsTranslations = getTranslations();